import { Enable, Page, rune, View } from 'rune-ts';
import { ERROR_MEMBERSHIP } from '../constant';
import { Alert } from '../../../shared/components/cells/Alert/Alert';
import { preventEscapeErrorJson } from '../../../shared/util/preventEscapeErrorJson';
import { ErrorBodyView } from '../../../renderApp/pages/Error/ErrorPage';
import { ConfigSentryF } from '../../../../../modules/Config/Sentry/F/Function/module/ConfigSentryF';
import { MembershipUtilS } from '../outbound/share';

export class MembershipErrorEnable<T extends object = object> extends Enable<T> {
  constructor(public override view: Page<T> | View<T>) {
    super(view);
  }

  onError = (errorMessage: keyof typeof ERROR_MEMBERSHIP) => {
    // token 이 만료된 상황, 모달 종료 이후 페이지 리프레시
    if (errorMessage === ERROR_MEMBERSHIP.ERROR_EXPIRED_TOKEN$) {
      return Alert.open(
        preventEscapeErrorJson({
          title: ET('mps2::membership::error::token_expired_title'),
          message: ET('mps2::membership::error::token_expired_description'),
        }),
      ).then(() => {
        window.location.reload();
      });
    }
    // 멤버십 서버 자체가 문제가 생긴 상황
    else {
      const is_mobile = !!rune.getSharedData(this.view)?.is_mobile;

      // 에러페이지 렌더링 전 멤버십 스피너 종료
      MembershipUtilS.toggleSpinner(false);

      this.view.element().innerHTML = new ErrorBodyView({
        is_mobile,
        status: errorMessage === ERROR_MEMBERSHIP.ERROR_INTERNAL_SERVER_ERROR$ ? 500 : 404,
      }).toHtml();

      ConfigSentryF.error(new Error(`멤버십 서버 에러 ${errorMessage}`));
    }
  };

  openWidgetRenderErrorModal = () => {
    return Alert.open(
      preventEscapeErrorJson({
        title: ET('mps2::membership::error::widget_activate_title'),
        message: ET('mps2::membership::error::widget_activate_description'),
      }),
    ).then(() => {
      window.location.reload();
    });
  };
}
